import {Fields} from '@vuex-orm/core';
import {RawRole} from '@/users/types/RawRole';
import {RoleName} from '@/users/types/RoleName';
import {StembleModel} from '@/common/models/StembleModel';

/**
 * Role class
 */
export default class Role extends StembleModel implements RawRole {
  static entity = 'Role';
  static nameMap: Record<string, number> = {};

  id!: number;
  name!: RoleName;
  permissions!: string[];

  static fields(): Fields {
    return {
      id: this.number(null),
      name: this.string(''),
      permissions: this.attr(null),
    };
  }

  // Lifecycle hooks to maintain the mapping
  static afterCreate(model: Role) {
    // TODO: this is undefined. Likely a bug in VuexORM, so work around by getting prototype
    const cls = Object.getPrototypeOf(model).constructor;
    const f = cls.updateMap.bind(cls);
    return f(model);
  }

  static afterUpdate(model: Role) {
    // See above comment about potential Vuex ORM bug
    const cls = Object.getPrototypeOf(model).constructor;
    const f = cls.updateMap.bind(cls);
    return f(model);
  }

  static updateMap(model: Role) {
    return (this.nameMap[model.name] = model.id);
  }

  static afterDelete(model: Role) {
    // See above comment about potential Vuex ORM bug
    const cls = Object.getPrototypeOf(model).constructor;
    const f = cls.deleteMapEntry.bind(cls);
    return f(model);
  }

  static deleteMapEntry(model: Role) {
    delete this.nameMap[model.name];
  }
}
